var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-padded"},[(_vm.loading)?_c('BLoading',{attrs:{"active":""}}):_vm._e(),(_vm.isProduct)?_c('Product',{attrs:{"inventory":_vm.inventory}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }